import {StatusMessageState} from '../_reducers/statusMessage';
import {StatusMessage} from '../types';

type LocalState = {
    statusMessage: StatusMessageState;
};

export const getStatusMessage = ({ statusMessage }: LocalState): StatusMessage | null => {
    return statusMessage.message;
};
